import React from "react";

export const Server = () => {
  return <div>server</div>;
};
